export interface IconProps extends React.SVGProps<SVGSVGElement> {
	size?: number | string
	className?: string
}

export const StudyIcon: React.FC<IconProps> = ({ size = 22, className, ...rest }) => (
	<svg
		width={size}
		height={(Number(size) / 22) * 16 || 16}
		viewBox='0 0 22 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className={className}
		{...rest}
	>
		<path
			d='M21 5L11 1L1 5L11 9L21 5ZM21 5V11M5 6.60001V12C5 12.7957 5.63214 13.5587 6.75736 14.1213C7.88258 14.6839 9.4087 15 11 15C12.5913 15 14.1174 14.6839 15.2426 14.1213C16.3679 13.5587 17 12.7957 17 12V6.60001'
			stroke='currentColor'
			strokeWidth={1.5}
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)
